var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement, useMemo, } from "react";
import SparklinesReferenceLine, { SparklinesReferenceLineTypes, } from "./SparklinesReferenceLine";
import SparklinesBars from "./SparklinesBars";
import SparklinesCurve from "./SparklinesCurve";
import SparklinesLine from "./SparklinesLine";
import SparklinesNormalBand from "./SparklinesNormalBand";
import SparklinesSpots from "./SparklinesSpots";
import SparklinesText from "./SparklinesText";
import dataToPoints from "./dataProcessing/dataToPoints";
var isSeries = function (data) {
    return data.length > 0 ? Array.isArray(data[0]) : false;
};
var Sparklines = function (props) {
    var _a = props.data, data = _a === void 0 ? [] : _a, limit = props.limit, _b = props.width, width = _b === void 0 ? 240 : _b, _c = props.height, height = _c === void 0 ? 60 : _c, _d = props.preserveAspectRatio, preserveAspectRatio = _d === void 0 ? "none" : _d, _e = props.margin, margin = _e === void 0 ? 2 : _e, svgWidth = props.svgWidth, svgHeight = props.svgHeight, style = props.style, max = props.max, min = props.min;
    if (data.length === 0) {
        return _jsx(_Fragment, {});
    }
    var points = useMemo(function () {
        if (isSeries(data)) {
            return data.map(function (series) { return dataToPoints({ data: series, limit: limit, width: width, height: height, margin: margin, max: max, min: min }); });
        }
        else {
            return dataToPoints({ data: data, limit: limit, width: width, height: height, margin: margin, max: max, min: min });
        }
    }, [data, limit, width, height, margin, max, min]);
    var svgOpts = {
        style: style,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        preserveAspectRatio: preserveAspectRatio,
    };
    if (svgWidth && svgWidth > 0)
        svgOpts.width = svgWidth;
    if (svgHeight && svgHeight > 0)
        svgOpts.height = svgHeight;
    return (_jsx("svg", __assign({}, svgOpts, { children: Children.map(props.children, function (child, index) {
            if (!isValidElement(child)) {
                return child;
            }
            var childPoints = isSeries(data) ? points[index] : points;
            if (!childPoints) {
                return child;
            }
            return cloneElement(child, {
                data: data,
                points: childPoints,
                width: width,
                height: height,
                margin: margin,
            });
        }) })));
};
export { Sparklines, SparklinesBars, SparklinesLine, SparklinesNormalBand, SparklinesReferenceLine, SparklinesReferenceLineTypes, SparklinesSpots, SparklinesText, SparklinesCurve, };
